import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  updateLAB_INFO,
  updateLAB_NAME,
  updateLAB_SEQ,
  updateSiteNo,
} from "./Redux/clinicalSite";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";

export default function SiteDropDownBox(props) {
  const { clinicalSite, siteDropDownBoxRef } = props;

  const dispatch = useDispatch();

  const [isDropDownOpened, setDropDownOpened] = useState(false);
  const [siteDataSource, setSiteDataSource] = useState(null);
  // const [selectedRowKeys, setSelectedRowKeys] = useState([
  //   clinicalSite.LAB_SEQ,
  // ]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([clinicalSite.ykiho]);

  useEffect(async () => {
    async function fetchData() {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/info/clinicalSiteInfo/site`
      );

      setSiteDataSource(result.data);
    }

    fetchData();
  }, []);

  // useEffect(() => {
  //   setSelectedRowKeys([clinicalSite.LAB_SEQ]);
  // }, [clinicalSite.LAB_SEQ]);
  useEffect(() => {
    setSelectedRowKeys([clinicalSite.ykiho]);
  }, [clinicalSite.ykiho]);

  const onOptionChanged = (e) => {
    if (e.name == "opened") {
      setDropDownOpened(e.value);
    }
  };

  const contentRender = () => {
    const onSelectionChanged = (args) => {
      setSelectedRowKeys(args.selectedRowKeys);

      if (args.selectedRowsData.length > 0) {
        setDropDownOpened(false);

        dispatch(
          updateLAB_INFO({
            // LAB_SEQ: args.selectedRowKeys[0],
            ykiho: args.selectedRowKeys[0],
            // SIDO:
            //   args.selectedRowsData[0].SIDO == "서울특별시" ||
            //   args.selectedRowsData[0].SIDO == "경기도" ||
            //   args.selectedRowsData[0].SIDO == "인천광역시"
            //     ? "서울경기"
            //     : "지방",
            SIDO:
              args.selectedRowsData[0].addr.startsWith("서울특별시") ||
              args.selectedRowsData[0].addr.startsWith("경기도") ||
              args.selectedRowsData[0].addr.startsWith("인천광역시")
                ? "서울경기"
                : "지방",
          })
        );

        if (siteDropDownBoxRef.current) {
          siteDropDownBoxRef.current.instance.option(
            "validationStatus",
            "valid"
          );
        }
      }
    };

    return (
      <DataGrid
        // keyExpr={"LAB_SEQ"}
        keyExpr={"ykiho"}
        dataSource={siteDataSource}
        remoteOperations={true}
        height={250}
        selectedRowKeys={selectedRowKeys}
        hoverStateEnabled={true}
        focusedRowEnabled={true}
        defaultFocusedRowKey={selectedRowKeys[0]}
        onSelectionChanged={onSelectionChanged}
      >
        <Scrolling mode={"virtual"} showScrollbar={"always"} />
        <Selection mode={"single"} />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Sorting mode={"multiple"} />

        {/* <Column dataField={"LAB_NAME"} caption="Site Name" sortIndex={0} /> */}
        <Column
          dataField={"yadmNm"}
          caption={"Site Name"}
          sortIndex={0}
          defaultSortOrder={"asc"}
          width={300}
        />
        <Column dataField={"addr"} caption="Address" />
      </DataGrid>
    );
  };

  return (
    <DropDownBox
      ref={siteDropDownBoxRef}
      opened={isDropDownOpened}
      // dropDownOptions={{ width: 700 }}
      dropDownOptions={{ width: 950 }}
      dataSource={siteDataSource}
      value={selectedRowKeys[0]}
      // displayExpr={"LAB_NAME"}
      displayExpr={"yadmNm"}
      // valueExpr={"LAB_SEQ"}
      valueExpr={"ykiho"}
      contentRender={contentRender}
      // readOnly={clinicalSite.action != "insert" ? true : false}
      onOptionChanged={onOptionChanged}
    />
  );
}
